var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"shade"},[_c('b-spinner'),_c('div',{staticClass:"message"},[_vm._v("Please wait...")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }